var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"facility-item"},[_c('vb-icon',{staticClass:"facility-item__icon",attrs:{"name":_vm.get_accommodation_facilities(_vm.item.id).icon,"color":'f1ae04',"size":14}}),_c('span',{staticClass:"facility-item__text"},[_vm._v(_vm._s(_vm.get_accommodation_facilities(_vm.item.id).label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }